module.exports = __webpack_public_path__ + "img/review_head_ph.bed30e1b.png";